import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Helmet } from 'react-helmet';
import Banner from '../assets/images/AboutUs/Banner.webp';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap';
const articles = [
    {
        type: 'pdf',
        filepath: '/images/Articles/U.S. Policy Toward Pakistan Must Prioritize Its People, Not Generals.pdf',
        title: 'U.S. Policy Toward Pakistan Must Prioritize Its People, Not Generals',
        thumbnail: "/images/Articles/US-Policy-GeneralsTowardsPakistan.png",
    },
    {
        type: 'pdf',
        filepath: '/images/Articles/Why Democracy in Pakistan Is Tied to Imran Khan — and Why the West Is Disillusioned.pdf',
        title: 'Why Democracy in Pakistan Is Tied to Imran Khan — and Why the West Is Disillusioned',
        thumbnail: "/images/Articles/WhyDemocracyInPakistan.png",
    },
];

const FpgDemocracyCorner = () => {

    const handlePdfClick = (filepath) => {
        const fullUrl = `${window.location.origin}${filepath}`;
        window.open(fullUrl, '_blank');
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title> First Pakistan Global </title>
            </Helmet>
            <Header />
            <section id="about-page">
                <div className="text-center">
                    <div
                        className="bg-common py-5"
                        style={{ backgroundImage: `url(${Banner})` }}
                    >
                        <div className="text-white fs-ss-68 py-4 py-md-5 my-md-5">
                            <div className="fw-700 text-uppercase">FPG Democracy Corner</div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                <div id="resources" className="container-fluid px-md-5">
                    <div className="row">
                        {articles.map((res, idx) => (
                            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                                <div className="card h-100 text-start rounded-0 position-relative overflow-hidden">
                                    {/* Image + Hover Overlay */}
                                    <div className="image-wrapper">
                                        <img
                                            src={res.thumbnail}
                                            alt={res.title}
                                            className="card-img-top img-fluid"
                                            style={{
                                                maxWidth: "100%",
                                                objectFit: "cover",
                                                objectPosition: "top center",
                                                height: "250px"
                                            }}
                                        />
                                        <div
                                            className="image-overlay"
                                            onClick={() => handlePdfClick(res.filepath)}
                                            title="Preview Document"
                                            style={{ cursor: "pointer", position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.4)' }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 576 512"
                                                width="28"
                                                height="28"
                                                fill="#fff"
                                            >
                                                <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Overlay Text */}
                                    <div
                                        className="position-absolute bottom-0 w-100 px-3 py-2"
                                        style={{
                                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                                            color: "#fff"
                                        }}
                                    >
                                        <div className="fw-bold" style={{ fontSize: "12px" }}>{res.date}</div>
                                        <div
                                            className="fw-bold"
                                            title={res.title}
                                            style={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                fontSize: "14px"
                                            }}
                                        >
                                            {res.title}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                </div>
                <div className="py-4 py-md-5" />
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default FpgDemocracyCorner;
